<template>
  <div class="content">
    <title-bar :title="$lang.Depósito"></title-bar>
    <!-- <van-nav-bar
      :title="$lang.Depósito"
      :border="false"
      @click-left="onClickLeft"
      fixed
      z-index="999"
    >
      <template #left>
        <van-icon name="arrow-left" size="20" color="#1F2A47" />
      </template>
    </van-nav-bar> -->

    <div style="padding: 20px 15px">
      <div v-if="hasOrderInfo" class="depo_cont">
        <img
          src="../../../assets/img/recharge/qb_icon.png"
          style="
            position: absolute;
            right: 0;
            bottom: 0;
            width: 150px;
            z-index: -2;
          "
        />
        <div style="position: relative; z-index: 999">
          <!-- 倒计时状态（29:59 到 00:00） -->
          <div
            v-if="orderStatus == '0' && countdown > 0"
            style="
              background: #ffda47;
              border-radius: 32px;
              color: #000000;
              padding: 5px 0;
              width: 80%;
              margin: 0 auto;
              text-align: center;
            "
          >
            <p style="font-weight: 800">{{ $lang.common_txt248 }}</p>
            <p style="font-weight: 800; font-size: var(--vk-fs-xl)">{{ timeCounmp }}</p>
          </div>

          <!-- 支付成功状态 -->
          <div
            v-if="orderStatus == '1'"
            style="
              background: #23b975;
              border-radius: 32px;
              color: #000000;
              width: 80%;
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              padding: 10px 0;
            "
          >
            <img src="../../../assets/img/recharge/sucee_sle.png" width="30" />
            <p class="m-l-10" style="font-weight: 800">
              {{ $lang.common_txt251 }}
            </p>
          </div>

          <!-- 倒计时结束或订单超时状态 -->
          <div
            v-if="(orderStatus == '0' && countdown <= 0) || orderStatus == '2'"
            style="
              background: #6e6e6e;
              border-radius: 32px;
              color: #000000;
              width: 80%;
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              padding: 10px 0;
            "
          >
            <img src="../../../assets/img/recharge/wait_sle.png" width="30" />
            <p class="m-l-10" style="font-weight: 800">
              {{ $lang.common_txt252 }}
            </p>
          </div>
          <p v-if="statusErrorMessage" class="pay-order-error">
            {{ statusErrorMessage }}
          </p>

          <div class="d-flex m-t-20" style="justify-content: center">
            <div class="d-flex">
              <ui-icon name="wallet" :size="20" />
              <p class="m-l-10" style="color: #d1e7f5">
                {{ $lang.common_txt86 }}
              </p>
            </div>
          </div>
          <p
            style="
              color: #ffffff;
              text-align: center;
              font-size: var(--vk-fs-2xl);
              font-weight: 700;
              margin-top: 10px;
            "
          >
            {{ $formatNumberWithCommas(paymentAmount) }}
            {{ infoDetail.paymentId || '' }}
          </p>
          <p style="text-align: center; color: #ffffff">
            ({{ infoDetail.wlType || '--' }})
          </p>

          <div
            v-if="paymentUrl"
            style="
              background: #ffffff;
              padding: 18px;
              border-radius: 15px;
              margin-top: 15px;
            "
            class="d-flex"
          >
            <vue-qr
              :text="paymentUrl"
              :size="100"
              class="content-c3--qr"
              :margin="1"
            ></vue-qr>
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-flow: column;
                height: 100px;
                word-break: break-all;
              "
            >
              <p>{{ $lang.common_txt249 }}</p>
              <p
                style="
                  background: #f2f5fb;
                  border: 1px solid #040404;
                  border-radius: 8px;
                  padding: 5px;
                "
              >
                {{ paymentUrl }}
              </p>
              <div
                class="d-flex"
                style="
                  background: #3979e3;
                  padding: 6px 0;
                  border-radius: 8px;
                  color: #ffffff;
                  justify-content: center;
                "
                @click="copyText"
              >
                <img src="../../../assets/img/recharge/copy_i.png" width="15" />
                <p class="m-l-5">{{ $lang.common_txt250 }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="m-t-20 f-t-13 f-w" style="color: #ffffff">
          <p class="m-b-10">{{ $lang.common_txt253 }}</p>
          <p class="m-b-10">{{ $lang.common_txt254 }}</p>
          <p>{{ $lang.common_txt255 }}</p>
        </div>
      </div>
      <van-empty
        v-else
        :image="require('../../../assets/img/common/img_no_data.png')"
        :description="$lang.noempt || 'No order data'"
      >
        <van-button round type="primary" size="small" @click="onClickLeft">
          {{ $lang.Recarregar || 'Deposit' }}
        </van-button>
      </van-empty>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import { UpayStatusorderNo } from '@/api/common'
import { failMessage, handleNeedLogin, hasPayOrderStatusEvidence, hasUnavailableMarker, isOk, normalizePayOrderStatus, safeParseJson, toNumber } from './safeFlow'
import { safeGetStorageItem, safeRemoveStorageItem, safeSessionStorage, safeSetStorageItem } from '@/utils/safeStorage'
import { copyTextToClipboard } from '@/components/share/shareSafety'

function localMarkerToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function isLocalActiveMarkerValue(value) {
  const token = localMarkerToken(value)
  return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(token)
}

function isLocalFalseProofValue(value) {
  const token = localMarkerToken(value)
  return value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)
}

function isLocalPositiveProofValue(value) {
  if (Array.isArray(value)) return false
  if (value && typeof value === 'object') return false
  if (typeof value === 'boolean') return value === true
  const token = localMarkerToken(value)
  if (!token || ['0', 'false', 'null', 'undefined', 'none', 'n/a', 'na', 'mock', 'placeholder', 'about:blank', '#', 'javascript:void(0)'].includes(token)) return false
  return !(
    token.includes('mock') ||
    token.includes('fallback') ||
    token.includes('read_only') ||
    token.includes('read-only') ||
    token.includes('read only') ||
    token.includes('readonly') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('unsupported') ||
    token.includes('not_supported') ||
    token.includes('not supported') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('data_unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('data unavailable') ||
    token.includes('dataunavailable') ||
    token.includes('read_failure') ||
    token.includes('read-failure') ||
    token.includes('read failure') ||
    token.includes('readfailure') ||
    token.includes('read_failed') ||
    token.includes('read-failed') ||
    token.includes('read failed') ||
    token.includes('readfailed') ||
    token.includes('disabled') ||
    token.includes('unavailable') ||
    token.includes('blocked') ||
    token.includes('query_only') ||
    token.includes('query-only') ||
    token.includes('query only') ||
    token.includes('only_query') ||
    token.includes('only-query') ||
    token.includes('only query') ||
    token.includes('write_blocked') ||
    token.includes('writeblocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('backend_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend_failure') ||
    token.includes('backendfailure') ||
    token.includes('backend failure') ||
    token.includes('backend-failure') ||
    token.includes('technical_marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical marker') ||
    token.includes('technical-marker') ||
    token.includes('payment_backend_blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('payment_status_unconfirmed') ||
    token.includes('paymentstatusunconfirmed') ||
    token.includes('payment status unconfirmed') ||
    token.includes('payment-status-unconfirmed') ||
    token.includes('need_login') ||
    token.startsWith('javascript:') ||
    token.startsWith('vbscript:') ||
    token.startsWith('data:')
  )
}

function isLocalUnavailableStatusToken(value) {
  const token = localMarkerToken(value)
  return !!token && (
    token.includes('dataunavailable') ||
    token.includes('data_unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('data unavailable') ||
    token.includes('read_only') ||
    token.includes('read-only') ||
    token.includes('read only') ||
    token.includes('readonly') ||
    token.includes('write_blocked') ||
    token.includes('write-blocked') ||
    token.includes('write blocked') ||
    token.includes('writeblocked') ||
    token.includes('backend_blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend_failure') ||
    token.includes('backend-failure') ||
    token.includes('backend failure') ||
    token.includes('backendfailure') ||
    token.includes('technical_marker') ||
    token.includes('technical-marker') ||
    token.includes('technical marker') ||
    token.includes('technicalmarker') ||
    token.includes('payment_backend_blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('payment backend blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment_status_unconfirmed') ||
    token.includes('payment-status-unconfirmed') ||
    token.includes('payment status unconfirmed') ||
    token.includes('paymentstatusunconfirmed') ||
    token.includes('fallback') ||
    token.includes('unsupported') ||
    token.includes('not_supported') ||
    token.includes('not-supported') ||
    token.includes('not supported') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('read_failure') ||
    token.includes('read-failure') ||
    token.includes('read failure') ||
    token.includes('read_failed') ||
    token.includes('read-failed') ||
    token.includes('read failed') ||
    token.includes('query_only') ||
    token.includes('query-only') ||
    token.includes('query only') ||
    token.includes('only_query') ||
    token.includes('only-query') ||
    token.includes('only query') ||
    token.includes('只支持查询') ||
    token.includes('仅支持查询')
  )
}

function isLocalStatusMarkerTextKey(key) {
  return [
    'status',
    'state',
    'result',
    'code',
    'errorcode',
    'msg',
    'message',
    'errormsg',
    'errormessage',
    'reason',
    'desc',
    'description',
    'readonlymessage'
  ].includes(localMarkerToken(key))
}

function isLocalUnavailableStatusResponse(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => isLocalUnavailableStatusResponse(item, depth + 1, seen))
  const markerKeys = [
    'dataUnavailable',
    'data_unavailable',
    'readOnly',
    'readOnlyQuery',
    'readOnlyAction',
    'readonly',
    'read_only',
    'read_only_query',
    'read_only_action',
    'writeBlocked',
    'write_blocked',
    'backendBlocked',
    'backend_blocked',
    'backendFailure',
    'backend_failure',
    'technicalMarker',
    'technical_marker',
    'paymentBackendBlocked',
    'payment_backend_blocked',
    'paymentStatusUnconfirmed',
    'payment_status_unconfirmed',
    'fallback',
    'unsupported',
    'notConnected',
    'not_connected',
    'readFailure',
    'read_failure',
    'readFailed',
    'read_failed',
    'notSupported',
    'not_supported',
    'queryOnly',
    'query_only',
    'onlyQuery',
    'only_query'
  ]
  const proofKeys = [
    'statusProof',
    'status_proof',
    'orderProof',
    'order_proof',
    'paymentUrlProof',
    'payment_url_proof',
    'payProof',
    'pay_proof',
    'serverOrderStatusProof',
    'server_order_status_proof'
  ]
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (proofKeys.includes(key) && (isLocalFalseProofValue(value) || !isLocalPositiveProofValue(value))) return true
    if (markerKeys.includes(key) && (isLocalActiveMarkerValue(value) || isLocalUnavailableStatusToken(value))) return true
    if (isLocalUnavailableStatusToken(key) && isLocalActiveMarkerValue(value)) return true
    if (value && typeof value === 'object') return isLocalUnavailableStatusResponse(value, depth + 1, seen)
    return isLocalStatusMarkerTextKey(key) && isLocalUnavailableStatusToken(value)
  })
}

function hasLocalPositiveStatusProof(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasLocalPositiveStatusProof(item, depth + 1, seen))
  const proofKeys = [
    'statusProof',
    'status_proof',
    'orderProof',
    'order_proof',
    'paymentUrlProof',
    'payment_url_proof',
    'payProof',
    'pay_proof',
    'serverOrderStatusProof',
    'server_order_status_proof'
  ]
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (proofKeys.includes(key)) return isLocalPositiveProofValue(value)
    if (value && typeof value === 'object') return hasLocalPositiveStatusProof(value, depth + 1, seen)
    return false
  })
}

function hasLocalPaidStatusClaim(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasLocalPaidStatusClaim(item, depth + 1, seen))
  const paidStatusKeys = [
    'payStatus',
    'pay_status',
    'paymentStatus',
    'payment_status',
    'orderStatus',
    'order_status',
    'statusCode',
    'status_code',
    'payState',
    'pay_state'
  ]
  const paidFlagKeys = ['paid', 'paySuccess', 'paymentSuccess']
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (paidStatusKeys.includes(key)) {
      const token = localMarkerToken(value)
      return ['1', 'success', 'successful', 'succeed', 'succeeded', 'paid', 'complete', 'completed', 'approved', 'done', 'finish', 'finished'].includes(token) ||
        token.includes('success') ||
        token.includes('paid') ||
        token.includes('complete')
    }
    if (paidFlagKeys.includes(key)) return value === true || localMarkerToken(value) === 'true'
    if (value && typeof value === 'object') return hasLocalPaidStatusClaim(value, depth + 1, seen)
    return false
  })
}

function hasLocalPositivePaymentUrlProof(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasLocalPositivePaymentUrlProof(item, depth + 1, seen))
  const proofKeys = [
    'paymentUrlProof',
    'payment_url_proof',
    'payProof',
    'pay_proof',
    'orderProof',
    'order_proof',
    'statusProof',
    'status_proof',
    'serverOrderStatusProof',
    'server_order_status_proof'
  ]
  return Object.keys(payload).some(key => {
    const value = payload[key]
    if (proofKeys.includes(key)) return isLocalPositiveProofValue(value)
    if (value && typeof value === 'object') return hasLocalPositivePaymentUrlProof(value, depth + 1, seen)
    return false
  })
}

function firstLocalValue(source, keys) {
  if (!source || typeof source !== 'object') return ''
  for (const key of keys) {
    const value = source[key]
    if (value !== undefined && value !== null && String(value).trim()) return value
  }
  return ''
}

function isLocalSafeBusinessValue(value) {
  const text = String(value == null ? '' : value).trim()
  const token = localMarkerToken(text)
  if (!text || isLocalUnavailableStatusToken(token)) return false
  return ![
    '0',
    'none',
    'null',
    'undefined',
    'placeholder',
    'mock',
    'about:blank',
    '#',
    'javascript:void(0)'
  ].includes(token)
}

function isLocalSafePaymentUrlValue(value) {
  const text = String(value == null ? '' : value).trim()
  const token = localMarkerToken(text)
  if (!isLocalSafeBusinessValue(text)) return false
  return !(
    token.startsWith('#') ||
    token.startsWith('about:') ||
    token.startsWith('javascript:') ||
    token.startsWith('vbscript:') ||
    token.startsWith('data:')
  )
}

function sanitizeInitialPayOrderInfo(source) {
  if (!source || typeof source !== 'object' || Array.isArray(source)) return {}
  if (hasUnavailableMarker(source) || isLocalUnavailableStatusResponse(source)) return {}
  const orderNo = firstLocalValue(source, [
    'orderNo',
    'order_no',
    'paymentOrderNo',
    'payment_order_no',
    'payOrderNo',
    'pay_order_no',
    'rechargeOrderNo',
    'recharge_order_no'
  ])
  if (!isLocalSafeBusinessValue(orderNo)) return {}
  const paymentUrl = firstLocalValue(source, [
    'url',
    'payUrl',
    'paymentUrl',
    'cashierUrl',
    'checkoutUrl',
    'redirectUrl',
    'qrcode',
    'qrCode'
  ])
  if (paymentUrl && !isLocalSafePaymentUrlValue(paymentUrl)) return {}
  const paymentUrlReady = Boolean(paymentUrl) && isLocalSafePaymentUrlValue(paymentUrl) && hasLocalPositivePaymentUrlProof(source)
  return {
    orderNo,
    paymentOrderNo: firstLocalValue(source, ['paymentOrderNo', 'payment_order_no', 'payOrderNo', 'pay_order_no']) || orderNo,
    paymentAmount: source.paymentAmount,
    paymentId: source.paymentId,
    wlType: source.wlType,
    url: paymentUrlReady ? paymentUrl : '',
    payUrl: paymentUrlReady ? paymentUrl : '',
    paymentUrl: paymentUrlReady ? paymentUrl : '',
    paymentUrlBlocked: Boolean(paymentUrl) && !paymentUrlReady,
    paymentUrlReady
  }
}

function localStatusFailMessage(data, fallback) {
  const message = failMessage(data, fallback)
  if (!message || /^network error$/i.test(String(message || '').trim())) {
    return fallback
  }
  if (isLocalUnavailableStatusResponse(data) && /^network error$/i.test(String(message || '').trim())) {
    return fallback
  }
  return message || fallback
}

function getSessionStorage() {
  try {
    if (typeof safeSessionStorage === 'function') return safeSessionStorage()
  } catch (e) { return null }
  return null
}
export default {
  name: 'payOrder',
  components: { VueQr },
  data() {
    return {
      infoDetail: sanitizeInitialPayOrderInfo(safeParseJson(safeGetStorageItem(getSessionStorage(), 'payOrderData'), {})),
      timeCounmp: '29:59', // 初始倒计时
      orderStatus: '0', // 默认未支付状态
      countdown: 30 * 60, // 30分钟倒计时（秒）
      timer: null, // 倒计时定时器
      apiTimer: null, // 接口调用定时器
      startTime: null, // 页面首次加载时间（用于计算是否已过1分钟）
      isApiPollingStarted: false, // 标记接口轮询是否已启动
      statusErrorMessage: '',
      statusErrorShown: false,
      statusPollingBlocked: false
    }
  },
  computed: {
    hasOrderInfo() {
      return Boolean(this.infoDetail && this.infoDetail.orderNo)
    },
    paymentAmount() {
      return toNumber(this.infoDetail && this.infoDetail.paymentAmount)
    },
    paymentUrl() {
      if (!this.infoDetail || !this.infoDetail.paymentUrlReady) return ''
      return (this.infoDetail.url || this.infoDetail.payUrl || this.infoDetail.paymentUrl) || ''
    }
  },
  mounted() {
    if (!this.hasOrderInfo) {
      this.$toast({ message: this.$lang.noempt || 'No order data', icon: 'cross' })
      return
    }
    // 初始化页面启动时间（优先从缓存读取，支持刷新后恢复）
    this.initStartTime()

    // 初始化倒计时
    this.initCountdown()

    // 检查是否需要启动接口轮询（支持刷新后恢复）
    this.checkAndStartApiPolling()
  },
  beforeRouteLeave(to, from, next) {
    // 路由离开时（退出当前页面），强制停止所有定时器和清理缓存
    this.forceStopAllTimersAndCache()
    next()
  },
  beforeDestroy() {
    // 组件销毁时，强制停止所有定时器和清理缓存（双重保障）
    this.forceStopAllTimersAndCache()
  },
  methods: {
    onClickLeft() {
      this.$jumpTo('/rechargeCont', {}, { replace: true })
    },
    copyText() {
      const lang = this.$lang || {}
      const successMessage = lang.Sucesso || 'Success'
      const failedMessage = lang.copy_failed || 'Copy failed'
      const emptyMessage = lang.noempt || 'No order data'
      const showToast = (payload) => {
        if (typeof this.$toast === 'function') {
          this.$toast(payload)
        }
      }
      if (!this.paymentUrl) {
        showToast({ message: emptyMessage, icon: 'cross' })
        return
      }
      try {
        const copied = copyTextToClipboard(this.paymentUrl)
        showToast({
          message: copied ? successMessage : failedMessage,
          icon: copied ? 'success' : 'cross'
        })
      } catch (e) {
        const copied = false
        showToast({
          message: copied ? successMessage : failedMessage,
          icon: copied ? 'success' : 'cross'
        })
      }
    },
    // 初始化页面启动时间
    initStartTime() {
      if (!this.infoDetail.orderNo) return
      const cacheKey = `startTime_${this.infoDetail.orderNo}`
      const cachedStartTime = safeGetStorageItem(getSessionStorage(), cacheKey)

      if (cachedStartTime) {
        // 从缓存恢复启动时间
        this.startTime = toNumber(cachedStartTime, Date.now())
      } else {
        // 首次加载，记录当前时间戳
        this.startTime = Date.now()
        safeSetStorageItem(getSessionStorage(), cacheKey, String(this.startTime))
      }
    },
    // 初始化30分钟倒计时
    initCountdown() {
      if (!this.infoDetail.orderNo) return
      const cacheKey = `countdown_${this.infoDetail.orderNo}`
      const remainingTime = safeGetStorageItem(getSessionStorage(), cacheKey)

      if (remainingTime) {
        // 从缓存中读取剩余时间（支持刷新后恢复）
        this.countdown = Math.max(toNumber(remainingTime, 30 * 60), 0)
      } else {
        this.countdown = 30 * 60 // 30分钟
      }

      // 更新倒计时显示
      this.updateCountdownDisplay()

      // 启动倒计时定时器
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
          // 缓存剩余时间
          safeSetStorageItem(getSessionStorage(), cacheKey, String(this.countdown))
          this.updateCountdownDisplay()

          // 倒计时过程中检查是否需要启动接口轮询
          this.checkAndStartApiPolling()
        } else {
          // 倒计时结束，强制停止所有定时器和缓存
          this.forceStopAllTimersAndCache()
        }
      }, 1000)
    },
    // 更新倒计时显示格式（mm:ss）
    updateCountdownDisplay() {
      const minutes = Math.floor(this.countdown / 60)
      const seconds = this.countdown % 60
      this.timeCounmp = `${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`
    },
    // 检查是否需要启动接口轮询
    checkAndStartApiPolling() {
      if (this.isApiPollingStarted && !this.apiTimer) {
        this.isApiPollingStarted = false
      }
      // 已经启动过轮询、支付成功、倒计时结束，不需要再启动
      if (
        this.isApiPollingStarted ||
        this.statusPollingBlocked ||
        this.orderStatus === '1' ||
        this.orderStatus === '2' ||
        this.countdown <= 0
      ) {
        return
      }

      // 计算已经过了多少时间（毫秒）
      const elapsedTime = Date.now() - this.startTime
      const oneMinute = 60 * 1000 // 1分钟

      if (elapsedTime >= oneMinute) {
        // 已经过了1分钟，立即启动接口轮询
        this.startApiPolling()
      } else {
        // 还没到1分钟，设置定时器，到时间后启动
        setTimeout(() => {
          this.startApiPolling()
        }, oneMinute - elapsedTime)
      }
    },
    // 开始接口轮询（刷新后也能保持3秒一次）
    startApiPolling() {
      if (this.isApiPollingStarted || this.statusPollingBlocked || !this.infoDetail.orderNo) return

      this.isApiPollingStarted = true
      safeSetStorageItem(getSessionStorage(), `isApiPollingStarted_${this.infoDetail.orderNo}`, 'true')

      // 先立即调用一次
      this.fetchOrderStatus()

      // 之后每3秒调用一次（刷新后会重新创建定时器，保持轮询）
      this.apiTimer = setInterval(() => {
        this.fetchOrderStatus()
      }, 3000)
    },
    // 调用订单状态接口
    async fetchOrderStatus() {
      if (!this.infoDetail.orderNo) return
      try {
        const data = await UpayStatusorderNo({
          orderNo: this.infoDetail.orderNo
        })
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) {
          this.forceStopAllTimersAndCache()
          return
        }
        if (isLocalUnavailableStatusResponse(data)) {
          this.showStatusError(localStatusFailMessage(data, 'This feature is temporarily unavailable. Please try again later.'))
          this.statusPollingBlocked = true
          this.stopApiPolling()
          return
        }
        const nextStatus = this.normalizePaymentStatus(data)
        if ((nextStatus === '1' || hasLocalPaidStatusClaim(data)) && !hasLocalPositiveStatusProof(data)) {
          this.showStatusError('This feature is temporarily unavailable. Please try again later.')
          this.statusPollingBlocked = true
          this.stopApiPolling()
          return
        }
        if (nextStatus === '0' && isOk(data) && !hasPayOrderStatusEvidence(data)) {
          this.showStatusError('This feature is temporarily unavailable. Please try again later.')
          return
        }
        if (isOk(data) || nextStatus !== '0') {
          this.orderStatus = nextStatus
          this.statusErrorMessage = ''
          this.statusErrorShown = false
          safeSetStorageItem(getSessionStorage(), `orderStatus_${this.infoDetail.orderNo}`, this.orderStatus)

          // 订单支付成功或倒计时结束，停止接口调用
          if (this.orderStatus === '1' || this.orderStatus === '2' || this.countdown <= 0) {
            this.forceStopAllTimersAndCache()
          }
        } else if (data && (data.status || data.code || data.success !== undefined)) {
          this.showStatusError(localStatusFailMessage(data, 'This feature is temporarily unavailable. Please try again later.'))
          if (hasUnavailableMarker(data)) {
            this.statusPollingBlocked = true
            this.stopApiPolling()
          }
        }
      } catch (error) {
        this.showStatusError(localStatusFailMessage(error, 'This feature is temporarily unavailable. Please try again later.'))
      }
    },
    showStatusError(message) {
      this.statusErrorMessage = message || 'This feature is temporarily unavailable. Please try again later.'
      if (this.statusErrorShown) return
      this.statusErrorShown = true
      this.$toast({ message: this.statusErrorMessage, icon: 'cross' })
    },
    normalizePaymentStatus(content = {}) {
      return normalizePayOrderStatus(content, this.orderStatus)
    },
    // 强制停止所有定时器和清理缓存（退出页面时使用）
    forceStopAllTimersAndCache() {
      // 清除倒计时定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      // 清除接口轮询定时器
      if (this.apiTimer) {
        this.stopApiPolling()
      }

      // 标记轮询已停止
      this.isApiPollingStarted = false

      // 清除所有相关缓存
      const orderNo = this.infoDetail && this.infoDetail.orderNo
      if (orderNo) {
        safeRemoveStorageItem(getSessionStorage(), `countdown_${orderNo}`)
        safeRemoveStorageItem(getSessionStorage(), `startTime_${orderNo}`)
        safeRemoveStorageItem(getSessionStorage(), `isApiPollingStarted_${orderNo}`)
        safeRemoveStorageItem(getSessionStorage(), `orderStatus_${orderNo}`)
      }
    },
    stopApiPolling() {
      if (this.apiTimer) {
        clearInterval(this.apiTimer)
        this.apiTimer = null
      }
      this.isApiPollingStarted = false
      const orderNo = this.infoDetail && this.infoDetail.orderNo
      if (orderNo) {
        safeSetStorageItem(getSessionStorage(), `isApiPollingStarted_${orderNo}`, 'false')
      }
    }
  },
  created() {
    // 页面创建时只保留订单查询参数；支付状态必须来自后端状态查询。
    const orderNo = this.infoDetail && this.infoDetail.orderNo
    if (orderNo) {
      safeRemoveStorageItem(getSessionStorage(), `isApiPollingStarted_${orderNo}`)
      safeRemoveStorageItem(getSessionStorage(), `orderStatus_${orderNo}`)
    }
    if (
      this.infoDetail &&
      (this.infoDetail.paymentUrlBlocked || this.infoDetail.url || this.infoDetail.payUrl || this.infoDetail.paymentUrl) &&
      !this.infoDetail.paymentUrlReady
    ) {
      this.statusErrorMessage = '当前支付链接缺少服务端创建订单证明，已隐藏二维码并阻止假支付入口。'
    }
  }
}
</script>
<style lang="less" scoped>
.depo_cont {
  background: #253b80;
  padding: 20px;
  position: relative;
  min-height: 320px;
  border-radius: 32px;
  z-index: 1;
}
.content-c3--qr {
  margin-right: 10px;
  border-radius: 8px;
  width: 100px;
  height: 100px;
}
.pay-order-error {
  width: 80%;
  margin: 10px auto 0;
  color: #ffda47;
  font-size: var(--vk-fs-xs);
  line-height: 18px;
  text-align: center;
}
</style>
